export default {
  baseUrl: "https://omang-api.cubettech.in",
  //baseUrl: "http://localhost:4000",
  portalUrl: "https://omang.cubettech.in/",
  productionUrl: "https://omang.odineducation.net",
};

export const qbAdminId = 134517299;

const siteConfig = {
  siteName: "Omang",
  siteIcon: "ion-flash",
  footerText: "Omang ©2020",
};
const themeConfig = {
  topbar: "themedefault",
  sidebar: "themedefault",
  layout: "themedefault",
  theme: "themedefault",
};
const language = "english";
export { siteConfig, language, themeConfig };
